<spike-editable-panel 
  title="Informazioni generali" 
  [(isEditing)]="formView"
  [isReadonly]="isReadOnly()"
  (onSave)="save()">
    <spike-position-general-form [form]="form"></spike-position-general-form>
    <spike-label label="Files"></spike-label>
    @if(documentsReady()){
      <spike-position-documents-form 
        [form]="documentsArray"
        (addRow)="addDocumentRow()"
        (deleteRow)="deleteDocumentRow($event)">
      </spike-position-documents-form>
    }

</spike-editable-panel>
